import { useState, useCallback } from "react";
import { getIdeAssignment, createIdeProject, createFileOrFolder, updateLabAssignmetDetails } from "../../services/ide-apis";
import { Link, useNavigate } from "react-router-dom";
import { global_var } from "../../services/cs-lab-config";
import { ReactComponent as MarksIcon } from '../../assets/logos/marks.svg';
import  noDataImage  from '../../assets/images/No notifcations.png'

import {
  message,
  Card,
  List,
  Typography,
  Divider,
  Row,
  Col,
  Button,
  Avatar,
  Empty
} from "antd";
import {
  CheckCircleFilled, LeftOutlined,
} from "@ant-design/icons";
import {
  formatDate,
  getIdeProjectTypeMetaData,
  getIdeProjectRoute,
  getIdeProjectLogo,
  trackEvent,
  getEvaluationStatusColor,
  getEvaluationStatusName,
} from "../utils/util-functions";
import CardSkeleton from "../utils/card-skeleton";
import LabProjectFilters from "../labAssignments/lab-assignment-filters";
import { ReactComponent as PendingIcon } from '../../assets/logos/pending.svg';
import { ReactComponent as ResubmissionIcon } from '../../assets/logos/resubmission.svg';

const { Meta } = Card;

const LabQuestionView = () => {
  document.title = "CS Lab | Lab Assignment";
  const navigate = useNavigate();
  const [totalLabQuestionsCount, setTotalLabQuestionsCount] = useState(0);
  const [assignmentLoading, setAssignmentLoading] = useState(false);
  const [labQuestion, setLabQuestion] = useState([]);

  const filtersChanged = useCallback((filters) => {
    setAssignmentLoading(true);

    const reqObj = {
      ...filters,
      fkCompanyId: global_var.company_id,
      portfolio: true,
      limitCount: 12,
      from: "csLab"
    };

    if (global_var.role_id === global_var.STUDENT_ROLE_ID) {
      reqObj.userLoginId = global_var.user_login_id;
    } else {
      reqObj.teacherUserLoginId = global_var.user_login_id;
    }

    reqObj.pageNo = reqObj.pageNo - 1;

    getIdeAssignment(reqObj).then((response) => {
      setAssignmentLoading(false);
      response = response.data;
      if (response.statusCode === 200) {
        setLabQuestion(response.labQuestions);
        setTotalLabQuestionsCount(response.totalLabQuestionsCount);
      } else {
        message.error(response.message);
      }
    });

  }, []);

  function navigateToIDE(labQuestionObj) { 

    const projectMetaData = getIdeProjectTypeMetaData(
      labQuestionObj.projectType
    );
    if (labQuestionObj.projectStatus === 'started' || labQuestionObj.evaluationStatus || labQuestionObj.projectStatus === 'submitted'){
      // const userToken = localStorage.getItem("token");
      const userToken = sessionStorage.getItem('token');

      trackEvent("open_lab_assignment_question_button_clicked",{
        ide_project_stack_name: labQuestionObj.projectType,
      });

      if (projectMetaData ? projectMetaData.route : false) {
        const fkResourceIdParam = labQuestionObj.resourceId ? labQuestionObj.resourceId : '';
        const fkMappingIdParam = labQuestionObj.fkActivityMapping ? labQuestionObj.fkActivityMapping : '';
        const fkUserMappingIdParam = labQuestionObj._id ? labQuestionObj._id : '';
        if (projectMetaData.openInNewTab) {
          window.open(
            projectMetaData.route +
              "?token=" +
              userToken +
              "&lmsProjectId=" +
              labQuestionObj.projectId
          );
        } else if (labQuestionObj.projectType === "sql2") {
          navigate(`${projectMetaData.route}${labQuestionObj.queryId}?fkResourceId=${fkResourceIdParam}&fkActivityMapping=${fkMappingIdParam}&fkUserActivityMappingId=${fkUserMappingIdParam}`);
        } 
        else if(labQuestionObj.projectType === 'vc3'){
          navigate(`${projectMetaData.route}${labQuestionObj.projectId}?fkResourceId=${fkResourceIdParam}&fkActivityMapping=${fkMappingIdParam}&fkUserActivityMappingId=${fkUserMappingIdParam}`);
        
        }else {
          navigate(projectMetaData.route + labQuestionObj.projectId);
        }
      } else {
        message.info("Coming soon.");
      }
    }else{
      
      trackEvent("start_new_lab_assignment_question_button_clicked",{
        ide_project_stack_name: labQuestionObj.projectType,
      });

      const fkResourceIdParam = labQuestionObj.resourceId ? labQuestionObj.resourceId : '';
      const fkMappingIdParam = labQuestionObj.fkActivityMapping ? labQuestionObj.fkActivityMapping : '';
      const fkUserMappingIdParam = labQuestionObj._id ? labQuestionObj._id : '';

      if(labQuestionObj.projectType === 'sql2'){
        navigate(`${projectMetaData.route}?fkResourceId=${fkResourceIdParam}&fkActivityMapping=${fkMappingIdParam}&fkUserActivityMappingId=${fkUserMappingIdParam}`);
      }
      else if(labQuestionObj.projectType === 'vc3'){
        navigate(`${projectMetaData.route}?fkResourceId=${fkResourceIdParam}&fkActivityMapping=${fkMappingIdParam}&fkUserActivityMappingId=${fkUserMappingIdParam}`);
      
      }else{
        const ideProjectData = {
          "fkResourceId": labQuestionObj.resourceId,
          "projectStatus":'started',
          "fkActivityMapping":labQuestionObj.fkActivityMapping,
          "fkUserActivityMappingId":labQuestionObj._id,
          "totalMark":labQuestionObj.totalMark,
          'dueDate':labQuestionObj.dueDate,
        }
        createIdeProject(labQuestionObj.title, labQuestionObj.projectType,ideProjectData).then((response) => {
          response = response.data;
          if (response.statusCode === 200) {
            message.success(response.message);
      
            // Create a file by default when creating project
            createFileOrFolder(response.ideProjectId, {
              fileOrFolderObject: {
                fileName: getIdeProjectTypeMetaData( labQuestionObj.projectType)
                  .defaultFileName,
                isFile: true,
                path: "",
              },
            }).then((fileResponse) => {
              fileResponse = fileResponse.data;
    
              if (fileResponse.statusCode === 200) {
                message.success(fileResponse.message);
                navigate(
                  getIdeProjectRoute(labQuestionObj.projectType) + response.ideProjectId
                );
              } else {
                message.error(fileResponse.message);
                navigate(
                  getIdeProjectRoute(labQuestionObj.projectType) + response.ideProjectId
                );
              }
            });
  
            const updateObj = {
              status: "started",
              fkActivityMapping: labQuestionObj.fkActivityMapping,
              fkUserLoginId:labQuestionObj.fkUserLoginId
            };
            updateLabAssignmetDetails(labQuestionObj.resourceId,updateObj).then((response) => {
              message.success(response.message)
            });
          } else {
            message.error(response.message);
          }
        });
      }
      
    }
  }

  return (
    <>
      <Row className="mt-4">
        <Col
          className="col d-flex align-items-center"
          justify="space-evenly"
          align="middle"
        >
          <Link to="/" className="mr-2">
            <span className="mt-2 back-button">
              <LeftOutlined  className=" h4" style={{ color: '#000000' }} />
            </span>
          </Link>
          <span className="m-1 h4 poppins-medium">
            Lab Assignment
          </span>
        </Col>
        <Col className="mt-2">
        <span className="poppins-bold text-midgrey"
            style={{ fontSize:'18px',
            }}
          >
            {global_var.academicYearName}
        </span>
        </Col>
      </Row>
      <Divider className="mt-1" style={{backgroundColor:"#D7BEF7"}} />

      <LabProjectFilters
        filtersChanged={filtersChanged}
        // hideAssignmentTypeFilter={projectStack ? true : false}
        totalLabQuestionsCount={totalLabQuestionsCount}
        hideClassFilter={global_var.needClass && (global_var.role_id !== global_var.STUDENT_ROLE_ID) ? false : true}
        hideDivisionFilter={global_var.needDivision && (global_var.role_id !== global_var.STUDENT_ROLE_ID) ? false : true}
      />

      <div className="row mx-2 left-padding">
        <div className="col">
          {assignmentLoading ? (
            <List
              grid={{
                gutter: 10,
                xs: 1,
                sm: 2,
                md: 3,
                lg: 3,
                xl: 3,
                xxl: 3,
              }}
              dataSource={Array(8).fill(0)}
              renderItem={() => (
                <List.Item className="mr-2 mb-3">
                  <CardSkeleton />
                </List.Item>
              )}
            />
          ) : (
            <List
            locale={{
              emptyText: (
                <Empty
                  image={noDataImage}
                  description={
                    <div>
                      <p className="poppins-regular" style={{fontSize:'18px'}}>No Projects yet!</p>
                      <p className="poppins-regular text-midgrey" style={{fontSize:'12px'}}>We’ll notify you once we have something for you </p>
                    </div>
                  }
                />
              ),
            }}
              grid={{
                gutter: 10,
                xs: 1,
                sm: 2,
                md: 3,
                lg: 3,
                xl: 3,
                xxl: 3,
              }}
              dataSource={labQuestion}
              renderItem={(labQuestionObj) => (
                
                <List.Item className="mr-2 mb-3">
                  <Card
                    className="glass specific-card"
                    actions={[
                      <div key="" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', 
                        paddingLeft: '15px', paddingRight: '15px'}} >
                        <span className="poppins-medium" style={{ marginRight: '8px', fontSize: '12px',
                          color: labQuestionObj.projectStatus === "started" ? "#E96358" : "#6EA000",}}
                        >
                          {labQuestionObj.evaluationStatus && labQuestionObj.evaluationStatus !== "pending evaluation" ? (
                            <span>
                                <span
                                    key="evaluationStatus"
                                    style={{
                                        color: getEvaluationStatusColor(labQuestionObj.evaluationStatus)
                                    }}
                                >
                                  {labQuestionObj.evaluationStatus === 'Ask for resubmission' ? <ResubmissionIcon /> :
                                    labQuestionObj.evaluationStatus === 'Evaluated' ? <CheckCircleFilled style={{ color: "#2AC14E", borderRadius: '4px', padding: '2px' }} /> :
                                    <PendingIcon />}
                                   {getEvaluationStatusName(labQuestionObj.evaluationStatus)}
                                </span>
                            </span>
                            ) : (
                              labQuestionObj.projectStatus && (
                                  labQuestionObj.projectStatus === "started" ? (
                                    <span className="poppins-medium" style={{color: labQuestionObj.daysLeft === "Due Today" || labQuestionObj.daysLeft === "Due Tomorrow" ? '#FF5C00' : '#FFA800'}}>
                                      {labQuestionObj.daysLeft}</span>
                                  ) : (
                                      <span>
                                          <CheckCircleFilled style={{ color: "#6EA000", borderRadius: '4px', padding: '2px' }} /> Submitted
                                      </span>
                                  )
                              )
                          )}
                          {!labQuestionObj.evaluationStatus && labQuestionObj.daysLeft && !labQuestionObj.projectStatus &&(
                            <span className="poppins-medium" style={{color: labQuestionObj.daysLeft === "Due Today" || labQuestionObj.daysLeft === "Due Tomorrow" ? '#FF5C00' : '#FFA800'}}>{labQuestionObj.daysLeft}</span>
                          )}
                        </span>
                        {/* {labQuestionObj.scoredMark && (labQuestionObj.evaluationStatus === "Evaluated" || labQuestionObj.evaluationStatus === "Ask for resubmission") &&
                          <span className="p-1 px-2 poppins-medium text-midgrey" style={{backgroundColor:'#F6F6F6',borderRadius:'5px',fontSize:'12px'}}>
                            Marks: <span className="text-dark">{labQuestionObj.scoredMark}</span>/{labQuestionObj.totalMark} <MarksIcon />
                          </span>
                        } */}
                        {(labQuestionObj.scoredMark !== null && labQuestionObj.scoredMark !== undefined) && (labQuestionObj.totalMark > 0) &&
                        (labQuestionObj.evaluationStatus === "Evaluated" || labQuestionObj.evaluationStatus === "Ask for resubmission") &&
                          <span className="p-1 px-2 poppins-medium text-midgrey" style={{backgroundColor:'#F6F6F6',borderRadius:'5px',fontSize:'12px'}}>
                            Marks: <span className="text-dark">{labQuestionObj.scoredMark}</span>/{labQuestionObj.totalMark} <MarksIcon />
                          </span>
                        }
                        <Button className={`poppins-medium ${labQuestionObj.projectStatus ? "open-button" : "start-button"}`}
                          style={{
                            borderColor: "#E96358",
                            borderRadius: "10px",
                            fontSize:'12px',
                            backgroundColor:labQuestionObj.projectStatus ? "#fff" : "",
                          }}
                          onClick={() => {
                            navigateToIDE(labQuestionObj);
                          }}
                          disabled={!labQuestionObj.projectStatus && labQuestionObj.daysLeft === "Overdue"}
                        >
                          {labQuestionObj.projectStatus ? "Open" : "Start"}
                        </Button>
                      </div>
                    ]}
                  >
                    <Meta
                      avatar={
                        <Avatar
                          size={{
                            xs: 24,
                            sm: 32,
                            md: 40,
                            lg: 34,
                            xl: 50,
                            xxl: 30,
                          }}
                          src={getIdeProjectLogo(
                            labQuestionObj.projectType
                          )}
                        />
                      }
                      title={
                        <Typography.Text className="poppins-medium" style={{fontSize:'16px'}}
                          ellipsis={{ tooltip: labQuestionObj.title }}
                        >
                          {labQuestionObj.title}
                        </Typography.Text>
                      }
                      description={
                        <div style={{textAlign:"left"}}>
                          <Typography.Text className="poppins-regular" 
                            style={{fontSize:'12px'}}            
                          >
                            {labQuestionObj.subSubjectName}
                          </Typography.Text>
                            <Typography.Text className="poppins-regular" style={{fontSize:'12px'}}
                              ellipsis={{
                                tooltip: formatDate(labQuestionObj.createdDate),
                              }}
                            >
                              <span style={{ color: 'grey'}}>Assigned by </span><span>{labQuestionObj.teacherName}</span>
                              <span style={{ color: 'grey'}}> on </span>
                              <span>{formatDate(labQuestionObj.createdDate)}</span>
                            </Typography.Text>
                        </div>
                      }
                    />
                  </Card>
                </List.Item>
              )}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default LabQuestionView;